/**
 * Describe the content from the site to display
 */
export interface SitePreviewContent {
    /**
     * ID of the site space to display.
     */
    siteSpaceId?: string;

    /**
     * Number of the change request to display.
     */
    changeRequestNumber?: number;

    /**
     * ID of a specific revision to display.
     */
    revisionId?: string;

    /**
     * Path of the page to display.
     */
    pagePath?: string;
}

/**
 * Get the URL for a site preview.
 */
export function getSiteURLForContent(rootURL: string, content: SitePreviewContent) {
    const url = new URL(rootURL);

    if (content.revisionId) {
        url.pathname = concatPaths(url.pathname, `/~/revisions/${content.revisionId}/`);
    } else if (content.changeRequestNumber) {
        url.pathname = concatPaths(url.pathname, `/~/changes/${content.changeRequestNumber}/`);
    }

    if (content.pagePath) {
        url.pathname = concatPaths(url.pathname, content.pagePath);
    }

    return url;
}

function concatPaths(root: string, path: string) {
    return `${root.endsWith('/') ? root.slice(0, -1) : root}${path.startsWith('/') ? path : `/${path}`}`;
}
